module.exports = "<div id=evaluatorrefer> <div class=u-row> <div class=u-col-12> <u-grid params=config:config></u-grid> </div> </div> </div> <style>#evaluatorrefer .ztree{overflow:hidden}#tree li span.button.ico_close{overflow:visible!important}#tree li span.button.ico_docu{overflow:visible!important}#tree li span.button.ico_open{overflow:visible!important}</style> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/evaluator/index.html
// module id = 267
// module chunks = 144